import React from 'react';
import { Button } from '../common/Button';

interface AuthCTAProps {
  slogan: string;
  ctaTitle: string;
  ctaSubtitle: string;
  buttonText: string;
  buttonHref?: string;
}

export const AuthCTA: React.FC<AuthCTAProps> = ({
  slogan,
  ctaTitle,
  ctaSubtitle,
  buttonText,
  buttonHref = '/discover',
}) => (
  <div className="w-full md:w-1/2 order-2 md:order-1 md:px-8 pt-16 pb-8 flex flex-col items-center md:items-start">
    <div className="max-w-md mx-auto">
      <div className="text-secondary-light [font-feature-settings:'liga'_off,'clig'_off] font-ambit text-[0.8125rem] font-[900] leading-[1.25rem] tracking-[0.0625rem] uppercase mb-4">
        {slogan}
      </div>
      <h1 className="text-secondary [font-feature-settings:'liga'_off,'clig'_off] font-orbikular italic text-[2.35rem] leading-[2.6rem] md:text-[4.65rem] md:leading-[4.95rem] font-bold tracking-[-0.03em] mb-4">
        {ctaTitle}
      </h1>
      <p className="text-[#3B5266] [font-feature-settings:'liga'_off,'clig'_off] font-ambit text-[1.0625rem] font-normal leading-[1.5625rem] mb-8">
        {ctaSubtitle}
      </p>
      <Button href={buttonHref} variant="primary" className="w-full md:w-60 px-12 py-2">
        {buttonText}
      </Button>
    </div>
  </div>
);
